import { Base } from '../../components/base-component';
import { AnalyticsService } from "../../services/analytics.service";

import './form-item-access-quote-upl.component.scss';

export class FormItemAccessQuoteUpl extends Base {

	form: HTMLFormElement;
	submitBtn: Element[];
	callMeBackButton: Element;
	applyOnlineButton: HTMLFormElement;

	creditCheck: HTMLFormElement;
	bttDate: HTMLFormElement;
	bttTime: HTMLFormElement;
	formFields: HTMLFormElement;

	thankYouContainer: HTMLFormElement;
	approvedContainer: HTMLFormElement;
	completeContainer: HTMLFormElement;

	innitialForm: HTMLFormElement;
	callMedBackForm: HTMLFormElement;
	applyOnlineForm: HTMLFormElement;

	constructor(
		element: Element
	) {
		super(element);
	}

	init() {
		this.form = this.element.querySelector('form') as HTMLFormElement;
		this.submitBtn = Array.from(this.element.querySelectorAll('.js-apply-now-upl__button'));
		this.callMeBackButton = this.element.querySelector('.js-apply-now-pc__button--cmb');
		this.applyOnlineButton = this.element.querySelector(".js-hs-applyOnline-button");

		this.creditCheck = this.element.querySelector("input[name=creditcheck]");
		this.bttDate = this.element.querySelector("input[name=date]");
		this.bttTime = this.element.querySelector("input[name=time]");
		this.formFields = this.element.querySelector(".form__fields--container");

		this.thankYouContainer = this.element.querySelector(".form__thankyou--container");
		this.approvedContainer = this.element.querySelector(".form__success--container-pc");
		this.completeContainer = this.element.querySelector(".form__success--container");

		this.innitialForm = this.element.querySelector(".form__fields--container-pcfields");
		this.callMedBackForm = this.element.querySelector(".form__fields--container-cmbfields");
		this.applyOnlineForm = this.element.querySelector(".form__success--container-applyOnline");
	}

	bindEvents() {

		this.submitBtn.map((item) => item.addEventListener('click', (event) => {
			const formFields: any = this.form.querySelectorAll('input, select');
			const validation = this.validationService.validate(formFields);
			const valid = Array.from(this.form.querySelectorAll(".form__group--error"));
			if (valid.length == 0) {
				this.SubmitApplicationFormAccessQuoteUpl(this.form, this.element.querySelector('.form__loader--container'), this.element.querySelector('.form__thankyou--container'));
			}
		}));
		if (this.callMeBackButton) {

			this.callMeBackButton.addEventListener('click', (event) => {
				if (this.bttDate) {
					this.bttDate.classList.add("form__input--required");
				}
				if (this.bttTime) {
					this.bttTime.classList.add("form__input--required");
				}

				this.formFields.classList.add("active");
				this.formFields.classList.remove("hidden");

				this.innitialForm.classList.add("hidden");
				this.innitialForm.classList.remove("active");

				this.callMedBackForm.classList.add("active");
				this.callMedBackForm.classList.remove("hidden");

				this.approvedContainer.classList.add("hidden");
				this.approvedContainer.classList.remove("active");

				this.applyOnlineForm.classList.add("hidden");
				this.applyOnlineForm.classList.remove("active");

				this.completeContainer.classList.add("hidden");
				this.completeContainer.classList.remove("active");

				this.creditCheck.value = "false";

				const _formName = this.form.getAttribute("data-frmcontainer");
				if (_formName != '') {
					this.form.setAttribute("data-frmcontainer", _formName + " cmb");
				}
				this.analyticsService.dtmRestartForm();
				// this.analyticsService.dtmFormNameUpdate("callmeback personal loan personal loan cmb");
			});
		}

		if (this.applyOnlineButton) {
			this.applyOnlineButton.addEventListener('click', (event) => {
				this.approvedContainer.classList.add("hidden");
				this.approvedContainer.classList.remove("active");

				this.applyOnlineForm.classList.add("active");
				this.applyOnlineForm.classList.remove("hidden");
			});
		}

		// Reset the form
		this.form.addEventListener('custom_form_reset_event', (e) => {
			let _formName: any = this.form.getAttribute("data-frmcontainer");
			_formName = _formName.replace(" cmb", '');
			this.form.setAttribute("data-frmcontainer", _formName);
		}, false);
	}

	SubmitApplicationFormAccessQuoteUpl(form: HTMLFormElement, loader: Element, thankyou: Element) {

		// additional containers
		let declined = form.querySelector('.form__declined--container');
		let success = form.querySelector('.form__success--container');
		let successUpl = form.querySelector('.form__success--container-pc');
		let error = form.querySelector('.form__error--container');
		let value = form.querySelector('.output-value');
		let name = Array.from(form.querySelectorAll('.form__success-container__firstname'));
		let qualifiedAmount = form.querySelector('.form__success-container__approvedamount');
		let _initialForm = form.querySelector(".form__fields--container-pcfields") as HTMLFormElement;
		let _callMeBackForm = form.querySelector(".form__fields--container-cmbfields") as HTMLFormElement;

		// fields
		const description: any = form.querySelector('input[name=description]');
		const firstName: any = form.querySelector('input[name=first-name]');
		const lastName: any = form.querySelector('input[name=last-name]');
		const contact: any = form.querySelector('input[name=phone-number]');
		const contact2: any = form.querySelector('input[name=phone-number-2]');
		const gross: any = form.querySelector('input[name=gross]');
		const monthlyexpenses: any = form.querySelector('input[name=monthlyexpenses]');
		const idNum: any = form.querySelector('input[name=identification]');
		const email: any = form.querySelector('input[name=email]');
		const date: any = form.querySelector('input[name=date]');
		const time: any = form.querySelector('select[name=time]');
		const _creditCheck: any = form.querySelector('input[name=creditcheck]');

		// loader + hide form
		const fieldsContainer: any = form.querySelector('.form__fields--container');
		loader.classList.add('active');
		fieldsContainer.classList.add('hidden');
		fieldsContainer.classList.remove('active');

		// variables
		let analyticsService = new AnalyticsService();
		let url = "/services/SubmitApplicationFormUPL.jsp";
		const config = {
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
				"Access-Control-Allow-Origin": "*",
				'X-Requested-With': 'XMLHttpRequest'
			}
		}
		let postData = '';

		if (description) {
			postData += 'description=' + description.value;
		}
		if (firstName) {
			postData += '&firstName=' + firstName.value;
		}
		if (lastName) {
			postData += '&lastName=' + lastName.value;
		}
		if (contact) {
			postData += '&contact=' + contact.value;
		}
		if (contact2) {
			postData += '&contact2=' + contact2.value;
		}
		if (gross) {
			postData += '&gross=' + gross.value;
		}
		if (monthlyexpenses) {
			postData += '&monthlyexpenses=' + monthlyexpenses.value;
		}
		if (idNum) {
			postData += '&idNum=' + idNum.value;
		}
		if (email) {
			postData += '&email=' + email.value;
		}
		if (date) {
			if (time) {
				if (time.value !== "Anytime") {
					postData += '&timeToCall=' + date.value + ' ' + time.value;
				} else {
					postData += '&timeToCall=anytime';
				}
			} else {
				postData += '&timeToCall=anytime';
			}
		}
		postData += '&source=' + this.isMobile() + '&creditcheck=' + _creditCheck.value;

		this.formsService.postForm(url, postData, config).then(response => {
			let data = response.data;

			// service ok
			loader.classList.remove('active');

			if (!data.error && (data.amount || data.code || data.leadID)) {
				if (data.amount) {
					analyticsService.dtmFormComplete('complete', 'true');
					thankyou.classList.add('active');
					declined.classList.remove('active');
					error.classList.remove('active');
					if (_creditCheck.value == "true") {
						successUpl.classList.add('active');
						successUpl.classList.remove('hidden');
						success.classList.remove('active');
						success.classList.add('hidden');
					}
					else {
						successUpl.classList.add('hidden');
						successUpl.classList.remove('active');
						success.classList.add('active');
						success.classList.remove('hidden');
					}
					name.map((_item) => {
						_item.innerHTML = firstName.value;
					});
					value.innerHTML = 'R' + data.amount;
					if (qualifiedAmount) {
						qualifiedAmount.innerHTML = data.amount;
					}
				} else if (data.code) {
					analyticsService.dtmFormComplete('complete', data.code);
					let _tmp = this.errors.find((item) => {
						return item.code = data.code
					});
					if (_tmp) {
						analyticsService.dtmRecordSiteError(_tmp.message);
					} else {
						analyticsService.dtmRecordSiteError('Access Quote Declined');
					}
					thankyou.classList.add('active');
					success.classList.remove('active');
					error.classList.remove('active');
					declined.classList.add('active');
				} else if (data.leadID) {
					_initialForm.classList.add("active");
					_initialForm.classList.remove("hidden");

					_callMeBackForm.classList.add("hidden");
					_callMeBackForm.classList.remove("active");

					analyticsService.dtmFormComplete('complete', data.leadID);

					thankyou.classList.add('active');
					thankyou.classList.remove('hidden');

					success.classList.add('active');
					success.classList.remove('hidden');

					error.classList.add('hidden');
					error.classList.remove('active');

					declined.classList.add('hidden');
					declined.classList.remove('active');
				} else {
					analyticsService.dtmFormComplete('complete', data.code);
					let _tmp = this.errors.find((item) => {
						return item.code = data.code
					});
					if (_tmp) {
						analyticsService.dtmRecordSiteError(_tmp.message);
					} else {
						analyticsService.dtmRecordSiteError('Access Quote Declined');
					}
					thankyou.classList.add('active');
					success.classList.remove('active');
					error.classList.remove('active');
					declined.classList.add('active');
				}
			} else {
				analyticsService.dtmRecordSiteError('noerrorcode|invalid fields|' + url);
				thankyou.classList.add('active');
				success.classList.remove('active');
				declined.classList.remove('active');
				error.classList.add('active');
			}
		}).catch(function (response) {
			// service failed
			analyticsService.dtmRecordSiteError('noerrorcode|service failure occured|' + url);
			loader.classList.remove('active');
			thankyou.classList.add('active');
			success.classList.remove('active');
			error.classList.add('active');
			declined.classList.remove('active');
		});
	}

	isMobile() {
		var isMobile = (/Mobile|iP(hone|od|ad)|Android|BlackBerry|IEMobile|Kindle|NetFront|Silk-Accelerated|(hpw|web)OS|Fennec|Minimo|Opera M(obi|ini)|Blazer|Dolfin|Dolphin|Skyfire|Zune/).test(navigator.userAgent.toLowerCase());
		if (isMobile) {
			return "MOB";
		} else {
			return "WEB";
		}
	}

	errors = [
		{
			"error": "Credit Decline 1",
			"message": "DD04_Score Decline",
			"code": "DD04"
		},
		{
			"error": "Decline 1",
			"message": "DA58_No Bureau Consent_PS",
			"code": "DA58"
		},
		{
			"error": "Decline 2",
			"message": "DA60_Under Admin Order_PS",
			"code": "DA60"
		},
		{
			"error": "Decline 3",
			"message": "DA61_Under Sequestration_PS",
			"code": "DA61"
		},
		{
			"error": "Decline 4",
			"message": "DA57_No Terms & Conditions_PS",
			"code": "DA57"
		},
		{
			"error": "Decline 5",
			"message": "DA53_Under Debt Review",
			"code": "DA53"
		},
		{
			"error": "Decline 6",
			"message": "DH67_Capture an RCP",
			"code": "DH67"
		},
		{
			"error": "Decline 7",
			"message": "DA59_Customer Has No Surplus",
			"code": "DA59"
		},
		{
			"error": "Decline 8",
			"message": "DD02_Adverse Status",
			"code": "DD02"
		},
		{
			"error": "Decline 9",
			"message": "DR15_ID Warning",
			"code": "DR15"
		},
		{
			"error": "Decline 10",
			"message": "DS47_No Bureau Information",
			"code": "DS47"
		},
		{
			"error": "Decline 11",
			"message": "DA97_Bureau Debt Review",
			"code": "DA97"
		},
		{
			"error": "Decline 12",
			"message": "DS43_Bureau Admin Order",
			"code": "DS43"
		},
		{
			"error": "Decline 13",
			"message": "DD38_Reduction order on file",
			"code": "DD38"
		},
		{
			"error": "Decline 14",
			"message": "DA18_Number of Dishonours L6M > 12",
			"code": "DA18"
		},
		{
			"error": "Decline 15",
			"message": "DA19_Significant Days in Excess L6M > 60",
			"code": "DA19"
		},
		{
			"error": "Decline 16",
			"message": "DD07_Bureau Not Clean",
			"code": "DD07"
		},
		{
			"error": "Decline 17",
			"message": "DR38_Bureau Installments Exceeds Income",
			"code": "DR38"
		},
		{
			"error": "Decline 18",
			"message": "DA36_Existing SBSA Loan on Record",
			"code": "DA36"
		},
		{
			"error": "Decline 19",
			"message": "DD24_MasterCard Delinquent",
			"code": "DD24"
		},
		{
			"error": "Decline 20",
			"message": "DD31_VAF Delinquent L6M",
			"code": "DD31"
		},
		{
			"error": "Decline 21",
			"message": "DD30_Home Loan Delinquent",
			"code": "DD30"
		},
		{
			"error": "Decline 22",
			"message": "DD39_WTP or ABIL Loan in Customer Profile",
			"code": "DD39"
		},
		{
			"error": "Decline 23",
			"message": "DR32_Customer is part time employed",
			"code": "DR32"
		},
		{
			"error": "Decline 24",
			"message": "DR58_Verification of Salary Required",
			"code": "DR58"
		},
		{
			"error": "Decline 25",
			"message": "DA15_Customer is under 18",
			"code": "DA15"
		},
		{
			"error": "Decline 26",
			"message": "DS16_Age > 65",
			"code": "DS16"
		},
		{
			"error": "Decline 27",
			"message": "DA08_No Identification Given",
			"code": "DA08"
		},
		{
			"error": "Decline 28",
			"message": "RA91_Advance Acnt Exposure - Refer to Credit",
			"code": "RA91"
		},
		{
			"error": "Decline 29",
			"message": "RA92_Student Loan Exposure - Refer to Credit",
			"code": "RA92"
		},
		{
			"error": "Decline 30",
			"message": "DR27_Foreign National",
			"code": "DR27"
		},
		{
			"error": "Decline 31",
			"message": "RA14_Sefl Employed MTL",
			"code": "RA14"
		},
		{
			"error": "Decline 32",
			"message": "RA96_Refer to Credit for Confirmation",
			"code": "RA96"
		},
		{
			"error": "Decline 33",
			"message": "DR33_Customer employment status is unknown",
			"code": "DR33"
		},
		{
			"error": "Decline 34",
			"message": "DA14_Non Resident",
			"code": "DA14"
		},
		{
			"error": "Decline 35",
			"message": "DP19_One Account in Customer Profile",
			"code": "DP19"
		},
		{
			"error": "Decline 36",
			"message": "DS49_Maximum Reprocess Allowed",
			"code": "DS49"
		},
		{
			"error": "Decline 37",
			"message": "DS21_Low Income Loan Recently Granted",
			"code": "DS21"
		},
		{
			"error": "Decline 38",
			"message": "DP95_LIUL Arrears",
			"code": "DP95"
		},
		{
			"error": "Decline 39",
			"message": "DE42_Existing Loans is in arrears",
			"code": "DE42"
		},
		{
			"error": "Decline 40",
			"message": "SD27_NLR Enquiry Last 1 Year",
			"code": "SD27"
		},
		{
			"error": "Decline 26",
			"message": "DS18_Occupation Status not met",
			"code": "DS18"
		},
		{
			"error": "Decline 20",
			"message": "DA38_GMI < 3000",
			"code": "DA38"
		},
		{
			"error": "Decline 21",
			"message": "DD06_Self Employed",
			"code": "DD06"
		},
		{
			"error": "Decline 15",
			"message": "DS09_Total Value of Judgments",
			"code": "DS09"
		},
		{
			"error": "Decline 13",
			"message": "DS22_SAPPL Adverse Status",
			"code": "DS22"
		},
		{
			"error": "Decline 11",
			"message": "DS23_Insufficient payment profile on Bureau",
			"code": "DS23"
		},
		{
			"error": "Refer 2",
			"message": "RR40_Requested Limit < Current Outstanding Balance",
			"code": "RR40"
		},
		{
			"error": "Refer 3",
			"message": "RA48_Age of Customer > 65",
			"code": "RA48"
		},
		{
			"error": "Decline 30",
			"message": "DD25_Unpaid Credits L6m",
			"code": "DD25"
		},
		{
			"error": "Decline 31",
			"message": "DS51_Missing Expenses",
			"code": "DS51"
		},
		{
			"error": "Decline 27",
			"message": "DD23_Age of account < 6 months",
			"code": "DD23"
		},
		{
			"error": "Decline 28",
			"message": "DD22_Recent limit increase",
			"code": "DD22"
		},
		{
			"error": "Decline 23",
			"message": "DD37_Product not Permitted",
			"code": "DD37"
		},
		{
			"error": "Decline 6",
			"message": "DA25_PL GMI < 6001 AND GMI < 8001",
			"code": "DA25"
		},
		{
			"error": "Decline 11",
			"message": "DA35_Existing RCP",
			"code": "DA35"
		},
		{
			"error": "Decline 13",
			"message": "DS40_Existing Loan",
			"code": "DS40"
		},
		{
			"error": "Decline 16",
			"message": "DR60_Existing Advanced Account",
			"code": "DR60"
		}
	];

}



// WEBPACK FOOTER //
// ./components-wpbbsa/form-item-access-quote-upl/form-item-access-quote-upl.component.ts